import React from "react";
import styled from "styled-components";
import { 
    MELOGY_TRANSPARENT, 
    MELOGY_WHITE, 
} from "../../../style/colors";
import {
    BUTTON_FONT_FAMILY,
    BUTTON_FONT_WEIGHT,
    BUTTON_LETTER_SPACING,
    TITLE_FONT_FAMILY,
    TITLE_LETTER_SPACING,
    TITLE_FONT_WEIGHT,
    FONT_SIZE_2XS,
    FONT_SIZE_4XS,
} from "../../../style/fontSettings";
import Slider from "../../slider/Slider";
import RangeSlider from "../../slider/RangeSlider";
import ColorPicker from "../../colorPicker/colorPickerForStyle";
import BackgroundImagePicker from "../../backgroundImagePicker/BackgroundImagePicker";
import { getDisplayName } from "../../../util/StyleSettingUtil";

const SettingContainer = styled.div`
    width: 100%;
    height: 64px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: ${MELOGY_TRANSPARENT};
`;

const StyledText = styled.div`
    font-family: ${BUTTON_FONT_FAMILY};
    letter-spacing: ${BUTTON_LETTER_SPACING};
    font-weight: ${BUTTON_FONT_WEIGHT};
    font-size: ${FONT_SIZE_2XS};
    color: ${MELOGY_WHITE};
    height: 32px;
    line-height: 32px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    padding-left: 2px;
    display: flex;
    align-items: center;
    user-select: none;
`;

const StyledName = styled.span`
    font-size: ${FONT_SIZE_4XS};
    font-family: ${TITLE_FONT_FAMILY};
    font-weight: ${TITLE_FONT_WEIGHT};
    letter-spacing: ${TITLE_LETTER_SPACING};
    margin-right: 4px;
`;

const SliderContainer = styled.div`
    height: 16px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const EmptySpace = styled.div`
    height: 16px;
    width: 100%;
`;

function StyleSetting({ styleSetting, updateStyleSettings, sliderDisplayValue, setSliderDisplayValue }) {
    const { name, inputType, value, lowerValue, higherValue } = styleSetting;

    const getValueText = () => {
        if (inputType === "SLIDER") {
            return sliderDisplayValue !== undefined ? sliderDisplayValue : value;
        } else if (inputType === "COLOR_PICKER") {
            return value;
        } else {
            return `${lowerValue} - ${higherValue}`;
        }
    };

    return (
        <>
            {inputType === "COLOR_PICKER" ? (
                <ColorPicker
                    color={value}
                    onChange={updateStyleSettings}
                />
            ) : inputType === "BACKGROUND_IMAGE_PICKER" ? (
                <BackgroundImagePicker
                    value={value}
                    onChange={updateStyleSettings}
                />
            ) : (
                <SettingContainer>
                    <StyledText>
                        <StyledName>{getDisplayName(name)}:</StyledName>
                        {getValueText()}
                    </StyledText>
                    <SliderContainer>
                        {inputType === "SLIDER" ? (
                            <Slider
                                styleSetting={styleSetting}
                                updateStyleSettings={updateStyleSettings}
                                sliderDisplayValue={sliderDisplayValue}
                                setSliderDisplayValue={setSliderDisplayValue}
                            />
                        ) : inputType === "RANGE_SLIDER" ? (
                            <RangeSlider
                                styleSetting={styleSetting}
                                updateStyleSettings={updateStyleSettings}
                            />
                        ) : null}
                    </SliderContainer>
                    <EmptySpace />
                </SettingContainer>
            )}
        </>
    );
}

export default StyleSetting;